import { render, staticRenderFns } from "./ModuleViewSelector.vue?vue&type=template&id=6e0f72e4&"
import script from "./ModuleViewSelector.vue?vue&type=script&lang=ts&"
export * from "./ModuleViewSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleViewSelector.vue?vue&type=style&index=0&id=6e0f72e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports